module.exports = __webpack_public_path__ + "img/dodo_large.7e53ecb8.png";